/* eslint-disable max-len */
import React from "react";
import { Container } from "../../../components/core/03-base/Container";
import { Div } from "../../../components/core/03-base/Div";
import { FlexRow } from "../../../components/core/03-base/Flex/Row";
import { Grid } from "../../../components/core/03-base/Grid";
import { Icon } from "../../../components/core/05-atoms/Icon";
import { ThemePalette, ThemePaletteState, ThemeShadowSizes } from "../../../theme/_Types";
import { WizardCard } from "./WizardCard";
/**
 *
 * @param props
 */
export var WizardFormItem = function (props) { return (React.createElement(Div, { theme: {
        padding: {
            "": { y: 1 },
            "sm": { y: 2 },
        },
    } },
    React.createElement(FlexRow, null,
        React.createElement(Grid, { size: { xs: 2, md: 1 } },
            React.createElement(Div, { theme: {
                    palette: props.isActive
                        ? ThemePalette.BRAND_ACCENT : ThemePalette.CONTRAST_PRIMARY,
                    paletteState: !props.isActive && props.isTouched ?
                        (props.isValid ? ThemePaletteState.SUCCESS : ThemePaletteState.DANGER) : undefined,
                    shadow: ThemeShadowSizes.TINY,
                }, className: "scl-o--item-counter-btn" }, !props.isActive && props.isTouched ?
                (props.isValid ? React.createElement(Icon, { name: "check" }) : React.createElement(Icon, { name: "exclamation" })) : React.createElement("span", null, props.id + 1)),
            !props.isLast && React.createElement("div", { className: "scl-o--item-counter-line" })),
        React.createElement(Grid, { size: { xs: 10, md: 11 }, theme: {
                shadow: ThemeShadowSizes.TINY,
            } },
            React.createElement(WizardCard, { title: props.title, collapsable: true, id: props.id, isValid: props.isValid, setActive: props.setActive, counter: props.counter }, props.isTable ? (props.component) : (React.createElement(Container, { theme: {
                    palette: ThemePalette.CONTRAST_PRIMARY,
                    padding: {
                        "": { y: 3 },
                        "sm": { y: 4 },
                    },
                } }, props.component))))))); };
